import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import { defValueCategoriaFinanceira, TCategoriaFinanceiro } from "../../types/api/financeiro/categorias-financeiro";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";

export default function SelectCategoria({
    value,
    onChange,
    required = false,
    error = false,
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    const inputLabel = value ? `${value.id ?? ''}${value.nome ? ` - ${value.nome}` : ''}` : ""

    return (
        <>
            <TextField
                {...{ required, error }}
                label={`Categoria`}
                variant="outlined"
                fullWidth
                onClick={() => setOpenModal(true)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: { readOnly: true }
                }}
                value={inputLabel}
                helperText={error ? "Campo obrigatório" : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose }}
                        title="Selecionar categoria"
                        queryPath="/financeiro/configuracoes/pesquisar-categorias"
                        defaultValue={value || defValueCategoriaFinanceira}
                        getItemKey={(item) => item.id}
                        getItemLabel={(item) => `${item.id} - ${item.nome}`}
                        onChange={(value) => {
                            onChange(value as TCategoriaFinanceiro)
                            handleClose()
                        }}
                    />
                </Dialog>

            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: TCategoriaFinanceiro
    onChange: (arg: TCategoriaFinanceiro | null) => void
    required?: boolean
    error?: boolean
}